export default "__VITE_ASSET__BbQIPkTu__"